import React from "react";
import { occurrencesRepetition, phraseRepetition, quantieme } from "./creneauHelpers";

const MAX_DATES = 8;

const dateCourte = (d, avecAnnee) =>
  `${d.setLocale("fr").toFormat("ccc")} ${quantieme(d.day)} ${d.setLocale("fr").toFormat("LLL")}${avecAnnee ? " " + d.year : ""}`;
const dateLongue = (d) =>
  `${d.setLocale("fr").toFormat("cccc")} ${quantieme(d.day)} ${d.setLocale("fr").toFormat("LLLL yyyy")}`;

// CE-1416 : sous la répétition, les créneaux qui seront ouverts, pour que l'agent voie
// ce que sa règle donne avant d'enregistrer (le premier mardi, un 7 qui tombe un samedi).
const ApercuRepetition = ({ slotCalendarConfig, debut }) => {
  const resultat = occurrencesRepetition(slotCalendarConfig, debut);

  return (
    <div role="status" aria-live="polite">
      {resultat && resultat.dates.length === 0 && (
        <div className="form-group">
          <div className="apercu-repetition apercu-repetition--vide">
            <i className="fa fa-exclamation-triangle" aria-hidden="true" />
            <div className="apercu-repetition__corps">
              <p className="apercu-repetition__titre">
                <b>Aucun créneau ne sera ouvert</b> avec cette répétition entre le {dateLongue(resultat.debut)} et le{" "}
                {dateLongue(resultat.fin)}.
              </p>
              <p className="apercu-repetition__note">Reculez la date « Jusqu'au » ou changez le jour.</p>
            </div>
          </div>
        </div>
      )}
      {resultat && resultat.dates.length > 0 && (
        <div className="form-group">
          <div className="apercu-repetition">
            <i className="fa fa-calendar-check" aria-hidden="true" />
            <div className="apercu-repetition__corps">
              <p className="apercu-repetition__titre">
                <b>
                  {resultat.dates.length} créneau{resultat.dates.length > 1 ? "x" : ""}
                </b>{" "}
                {phraseRepetition(slotCalendarConfig, debut)}, jusqu'au {dateLongue(resultat.fin)}.
              </p>
              <ul className="apercu-repetition__dates">
                {(resultat.dates.length > MAX_DATES ? resultat.dates.slice(0, MAX_DATES - 2) : resultat.dates).map(
                  (d) => (
                    <li key={d.toISODate()}>{dateCourte(d, d.year !== resultat.debut.year)}</li>
                  ),
                )}
                {resultat.dates.length > MAX_DATES && (
                  <li className="apercu-repetition__plus">
                    … et {resultat.dates.length - (MAX_DATES - 2)} autres jusqu'au{" "}
                    {dateCourte(resultat.dates[resultat.dates.length - 1], true)}
                  </li>
                )}
              </ul>
              {resultat.sautes.length > 0 && (
                <p className="apercu-repetition__saute">
                  <i className="fa fa-exclamation-triangle" aria-hidden="true" /> Pas de créneau le{" "}
                  {resultat.sautes.map(dateLongue).join(", le ")} : week-end.
                </p>
              )}
              <p className="apercu-repetition__note">Les jours de fermeture du site sont retirés à l'enregistrement.</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApercuRepetition;
